import { createSlice } from "@reduxjs/toolkit";
import duplicateStudy from "@custom/rtk-apis/DCM4CHEE/duplicateStudy";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const duplicateStudySlice = createSlice({
  name: "duplicateStudySlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(duplicateStudy.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(duplicateStudy.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = '201';
        state.result = payload;
        state.msg = 'Fetched from PACS';
      })
      .addCase(duplicateStudy.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
        state.error = 'Something went wrong!'
      });
  },
});

export default duplicateStudySlice.reducer;
